export default __webpack_public_path__ + "static/media/button_a.ff00819d.png";